import documentRevisionsReducer from './reducers';

export { default as documentRevisionsActions } from './actions';
export { default as documentRevisionsSelectors } from './selectors';

export default documentRevisionsReducer;
